import * as React from "react";
const SvgEllipseTop = (props) => /* @__PURE__ */ React.createElement("svg", { width: 205, height: 137, viewBox: "0 0 205 137", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("ellipse", { opacity: 0.03, cx: 166.614, cy: 24, rx: 166.614, ry: 113, fill: "currentColor" }));
export default SvgEllipseTop;
